import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'DurationPills' }

import { computed, nextTick, reactive, ref, type PropType } from 'vue'
import { sortDurations } from '@/util/pricing'

interface DurationEntry {
  duration_minutes: number
  is_default: boolean | number
  position?: number
}

// Runtime declaration: a TS-only `value: number | null` compiles to a required [Number, null]
// prop, and Vue 2 then rejects the null that means "default duration selected".

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  durations: { type: Array as PropType<DurationEntry[]>, default: () => [] },
  value: { type: Number as PropType<number | null>, default: null },
  disabled: { type: Boolean, default: false }
},
  emits: ["input", "add", "remove", "set-default"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', minutes: number | null): void
  (e: 'add', minutes: number): void
  (e: 'remove', minutes: number): void
  (e: 'set-default', minutes: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const DEFAULT_KEY = 'default'

// Same order as every other surface: ascending by minutes
const sorted = computed(() => sortDurations(props.durations || []) as DurationEntry[])

const options = computed(() => sorted.value.map(d => ({
  value: d.is_default ? DEFAULT_KEY : Number(d.duration_minutes),
  label: `${d.duration_minutes} min${d.is_default ? ' (default)' : ''}`
})))

const activeValue = computed(() => (props.value === null || props.value === undefined ? DEFAULT_KEY : Number(props.value)))

const activeDuration = computed(() => {
  if (props.value === null || props.value === undefined) {
    return sorted.value.find(d => !!d.is_default) || null
  }
  return sorted.value.find(d => Number(d.duration_minutes) === Number(props.value)) || null
})

function onSelect(value: string | number) {
  emit('input', value === DEFAULT_KEY ? null : Number(value))
}

const adding = ref(false)
const newMinutes = ref<number | undefined>(undefined)
const addError = ref('')
const minutesField = ref<any>(null)

function startAdd() {
  adding.value = true
  newMinutes.value = undefined
  addError.value = ''
  nextTick(() => {
    const el = minutesField.value && minutesField.value.$el ? minutesField.value.$el.querySelector('input') : null
    if (el) el.focus()
  })
}

function cancelAdd() {
  adding.value = false
  addError.value = ''
}

function confirmAdd() {
  const minutes = Number(newMinutes.value)
  if (!Number.isInteger(minutes) || minutes <= 0) {
    addError.value = 'Enter the duration in whole minutes'
    return
  }
  if ((props.durations || []).some(d => Number(d.duration_minutes) === minutes)) {
    addError.value = 'That duration already exists'
    return
  }
  addError.value = ''
  adding.value = false
  emit('add', minutes)
}

const confirmRemove = reactive({ show: false })

const removeMessage = computed(() => {
  const d = activeDuration.value
  return d ? `Remove the ${d.duration_minutes} minute duration and its pricing categories?` : ''
})

function doRemove() {
  confirmRemove.show = false
  if (activeDuration.value) emit('remove', Number(activeDuration.value.duration_minutes))
}

return { __sfc: true,props, emit, DEFAULT_KEY, sorted, options, activeValue, activeDuration, onSelect, adding, newMinutes, addError, minutesField, startAdd, cancelAdd, confirmAdd, confirmRemove, removeMessage, doRemove }
}

})